import { Button, Link } from "@material-ui/core";
import React from "react";

export const SuccessMessage = ({ tokenId, tokenizeAgain }) => (
  <div className="success-section">
    <h1>
      Done! Well that was easy, right?{" "}
      <span role="img" aria-label="smile">
        ☺️
      </span>
    </h1>
    <p>You've just created a token! Your token ID is...</p>
    <div>
      <span className="token-identifier-container">{tokenId}</span>
    </div>
    <Button
      color="primary"
      variant="contained"
      component={Link}
      target="_blank"
      href="https://portal.basistheory.com/register"
    >
      Sign me up
    </Button>
    <Button
      color="primary"
      variant="outlined"
      type="button"
      className="spacing-button"
      onClick={tokenizeAgain}
    >
      Try tokenizing again
    </Button>
  </div>
);
